// In production the app is served by the BFF, so relative URLs hit the same origin.
// In development the dev server runs separately — call the BFF explicitly (default :3001).
// Optional: set REACT_APP_BFF_URL in .env if your BFF runs elsewhere.
export const BFF_URL =
  process.env.NODE_ENV === "production"
    ? ""
    : (process.env.REACT_APP_BFF_URL || "http://localhost:3001");